export const FIRST_LOAD_PAGE = 'FIRST_LOAD_PAGE';
export const SET_GLOBAL_LOADING = 'SET_GLOBAL_LOADING';

export const SET_2FA_QR_CODE = 'SET_2FA_QR_CODE';
export const SET_2FA_ENABLED = 'SET_2FA_ENABLED';
